module.exports = __webpack_public_path__ + "img/l_Biometrocs.95c7fa1a.svg";